import { useCallback } from "react"

import { useApiCommand } from "hooks/core/useApiCommand"
import { getQuestionnaireSnapshot } from "api/Repos/questionnaire"
import { QuestionnaireSnapshotGetResponse } from "types/questionnaire.types"
import { useProjectOwner } from "./useProjectOwner"

/**
 * The saved copy of one of the open project's versions (restore).
 */
export const useQuestionnaireAudit = () => {
  const owner = useProjectOwner()
  const [getSnapshot] = useApiCommand<
    [string, string, string],
    QuestionnaireSnapshotGetResponse
  >(getQuestionnaireSnapshot)
  const getSnapshotById = useCallback(
    (projectId: string, rawHash: string): Promise<QuestionnaireSnapshotGetResponse> =>
      getSnapshot(projectId, owner, rawHash),
    [getSnapshot, owner]
  )
  return { getSnapshotById }
}
